module.exports = __webpack_public_path__ + "assets/images/icons/religion.svg?v=7646dbe1";